module.exports = __webpack_public_path__ + "img/dumbledores_got_style.12347f2c.jpg";